type KYCStatus = 'never_applied' | 'pending' | 'approved' | 'rejected';

export type Plus = {
  kycStatus: KYCStatus | '';
  whatIsPEP: string;
  merchantSpecialLimitFlags: {
    referrer?: string;
    referrerChannel?: string;
  } | null;
  highTicketMerchantPending: {
    name: string;
    createdAt: string;
  } | null;
};

export enum PlusCardKind {
  UNAVAILABLE,
  KYC_PENDING,
  HOUKATSU_PENDING,
  PEP_REQUIRED,
  PAC_REQUIRED,
  APPROVED,
  REJECTED,
  CLOSED,
  APPLE_PENDING,
  APPLE_PAC_REQUIRED,
  APPLE_APPROVED,
}
